import _ from 'underscore';
import classNames from 'classnames';
import { Button } from '@fluentui/react-components';
import { AddRegular } from '@fluentui/react-icons';
import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';

import { keyCode } from '@bingads-webui/keycode';
import { FilterType } from '../../model/filter-type';
import { ViewAllFiltersButton } from './view-all-filters-button';
import { usePerformanceFilterBarReadonlyStyle } from './styles';

const ReadonlyFilterBar = ({
  filters,
  onRenderFilter,
  onClickFilter,
  onClickAddFilterButton,
  i18n,
}) => {
  const classes = usePerformanceFilterBarReadonlyStyle();
  const onKeyPress = (event, filter, index) => {
    if (event.which === keyCode.Enter || event.which === keyCode.Space) {
      onClickFilter(filter, index);
    }
  };

  const filterListRef = useRef();
  const onFilterBlur = () => {
    // reset scroll position to 0
    if (filterListRef.current) {
      filterListRef.current.scrollTo(0, 0);
    }
  };

  return (
    <div className={classNames('filterBarReadonlyContainer', classes.filterBarReadonlyContainer)}>
      <div className="filter-list" ref={filterListRef} onBlur={onFilterBlur}>
        {filters.map((filter, index) => (
          filter.type === FilterType.SearchText ?
            onRenderFilter({
                filter,
                index,
                isLast: index === filters.length - 1,
                isFirst: index === 0,
              }) :
            <Fragment key={`filter-${filter.id}`}>
              <span
                onClick={() => onClickFilter(filter, index)}
                tabIndex="0"
                role="button"
                onKeyDown={event => onKeyPress(event, filter, index)}
              >
                {onRenderFilter({
                  filter,
                  index,
                  isLast: index === filters.length - 1,
                  isFirst: index === 0,
                })}
              </span>
            </Fragment>
        ))}
      </div>
      <ViewAllFiltersButton filters={filters} onClickFilter={onClickFilter} i18n={i18n} />
      <Button className={classNames('add-filter-button', classes.addFilterButton)} icon={<AddRegular />} name="add filter" onClick={onClickAddFilterButton}>{i18n.getString('Add filter')}</Button>
    </div>
  );
};

ReadonlyFilterBar.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  onRenderFilter: PropTypes.func.isRequired,
  onClickFilter: PropTypes.func,
  onClickAddFilterButton: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

ReadonlyFilterBar.defaultProps = {
  filters: [],
  onClickFilter: _.noop,
  onClickAddFilterButton: _.noop,
};

export const PerformanceReadonlyFilterBar
  = React.memo(ReadonlyFilterBar);
